import {Component} from 'panel';

import {onAnimationEnd, offAnimationEnd} from 'common/util/dom';
import {registerMPElement} from 'common/util/register-element';

import css from './index.styl?inline';
import template from './index.jade';

const states = Object.freeze({
  notSent: `NOT_SENT`,
  marked: `MARKED_USEFULNESS`,
  thanks: `SHOWING_THANK_YOU`,
  alreadySent: `ALREADY_SENT`,
});

const nextStates = Object.freeze({
  [states.notSent]: states.marked,
  [states.marked]: states.thanks,
  [states.thanks]: states.alreadySent,
  [states.alreadySent]: states.alreadySent,
});

/*
 * This class is a simple widget which captures useful/not-useful feedback. It animates
 * the transition and emits a change event. Persistence is up to the caller.
 */
class SmartHubFeedbackButton extends Component {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      disable: `boolean`,
    };
  }

  get states() {
    return states;
  }

  get nextStates() {
    return nextStates;
  }

  get config() {
    return {
      template,
      css,
      useShadowDom: true,
      defaultState: {
        status: this.states.notSent,
      },
      helpers: {
        handleSentFeedback: (ev, isUseful) => {
          ev.preventDefault();
          ev.stopPropagation();

          this.advanceToNextState();

          this.dispatchEvent(
            new CustomEvent(`change`, {
              detail: {
                isUseful,
                sentFeedbackAtMs: new Date().getTime(),
              },
              bubbles: true,
            }),
          );
        },
      },
    };
  }

  advanceToNextState() {
    this.update({
      status: this.nextStates[this.state.status],
    });
  }

  connectedCallback() {
    super.connectedCallback(...arguments);
    if (!this._advanceState) {
      this._advanceState = () => this.advanceToNextState();
      onAnimationEnd(this.el, this._advanceState);
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback(...arguments);
    if (this._advanceState) {
      offAnimationEnd(this.el, this._advanceState);
    }
  }
}

export default registerMPElement(`mp-smart-hub-feedback-button`, SmartHubFeedbackButton);
